import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { generatePDF, generateCSV, importCSV } from '../utils/pdfGenerator';
import { COLORS } from '../utils/constants';

const { FiDownload, FiUpload, FiStar } = FiIcons;

const MagicDownload = ({ data, activeObject, activeMeter, onDownload, onImport }) => {
  const importInputRef = useRef(null);

  const handleMagicDownload = async () => {
    try {
      // Generate PDF
      await generatePDF(data, activeObject, activeMeter);
      
      // Generate CSV
      generateCSV(data);
      
      onDownload();
    } catch (error) {
      console.error('Error generating files:', error);
      alert('Fehler beim Erstellen der Dateien. Bitte versuchen Sie es erneut.');
    }
  };

  const handleImport = (e) => {
    const file = e.target.files[0];
    if (file) {
      importCSV(file, (importedData) => {
        if (window.confirm('Möchten Sie die importierten Daten mit Ihren aktuellen Daten zusammenführen?')) {
          onImport(importedData);
          alert('Daten erfolgreich importiert!');
        }
      });
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 border-2" style={{ borderColor: COLORS.secondary }}>
      <div className="flex items-center gap-3 mb-4">
        <motion.div
          animate={{ 
            rotate: [0, 5, -5, 0],
            scale: [1, 1.1, 1]
          }}
          transition={{ 
            duration: 2,
            repeat: Infinity,
            repeatDelay: 3
          }}
          className="text-3xl"
        >
          <SafeIcon icon={FiStar} style={{ color: COLORS.secondary }} />
        </motion.div>
        <div>
          <h3 className="text-xl font-bold" style={{ color: COLORS.primary }}>
            Magic Download
          </h3>
          <p className="text-sm text-gray-600">
            PDF-Bericht + CSV-Sicherung mit einem Klick
          </p>
        </div>
      </div>

      <div className="flex flex-wrap gap-3">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={handleMagicDownload}
          className="flex-1 min-w-[200px] py-4 px-6 text-white font-bold rounded-lg shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3 text-lg relative overflow-hidden"
          style={{ backgroundColor: COLORS.secondary }}
        >
          <motion.div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-20"
            animate={{ x: ['-100%', '200%'] }}
            transition={{ duration: 2, repeat: Infinity, repeatDelay: 1 }}
          />
          <SafeIcon icon={FiDownload} size={24} />
          <span>PDF + CSV herunterladen</span>
        </motion.button>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => importInputRef.current?.click()}
          className="py-4 px-6 border-2 font-bold rounded-lg shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3 bg-white"
          style={{ borderColor: COLORS.secondary, color: COLORS.secondary }}
        >
          <SafeIcon icon={FiUpload} size={20} />
          <span>CSV importieren</span>
        </motion.button>

        <input
          ref={importInputRef}
          type="file"
          accept=".csv"
          onChange={handleImport}
          className="hidden"
        />
      </div>

      <div className="mt-4 p-3 bg-orange-50 border border-orange-200 rounded-lg text-sm text-orange-800">
        <strong>💡 Tipp:</strong> Der Magic Download erstellt automatisch einen schön formatierten PDF-Bericht 
        mit allen Ihren Daten UND eine CSV-Sicherungsdatei. Beide Dateien werden sofort heruntergeladen.
      </div>
    </div>
  );
};

export default MagicDownload;